/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Partner_Home_WelcomeInputs */



/**
* | output |
* | --- |
* | "Welcome back, {name}" |
*
* @param {Partner_Home_WelcomeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_welcome = /** @type {((inputs: Partner_Home_WelcomeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_WelcomeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Willkommen zurück, ${i?.name}`)
	return /** @type {LocalizedString} */ (`Welcome back, ${i?.name}`)
});